import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {CashReport} from "../model/cashReport";


@Component({
    selector: 'open-cash-report-dialog',
    templateUrl: './openCashReportDialog.component.html',
    styleUrls: ['./openCashReportDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class OpenCashReportDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    areCommentsRequired = false;
    lastCashReport: CashReport;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<OpenCashReportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.lastCashReport = _data.lastCashReport;

        this.form = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            openDayCash: [this.lastCashReport?this.lastCashReport.cash:0, Validators.required],
            comments: [''],
        });
    }

    commentsRequired(): void {
        this.areCommentsRequired = this.lastCashReport && this.lastCashReport.cash.toString() !== this.form.get('openDayCash').value.toString();
    }
}
